import React from 'react';
import { observer } from 'mobx-react';
import DraftItemListService from '../services/DraftItemListService';
import DraftItemListFilter from './DraftItemListFilter';

const DraftItemListFilterContainer = () => (
  <DraftItemListFilter
    values={DraftItemListService.form.getValues()}
    onChange={DraftItemListService.form.setValue}
    onReset={DraftItemListService.form.reset}
    onSearch={DraftItemListService.handleTableChange.bind(null, { current: 1 })}
    fetching={DraftItemListService.fetch.fetching}
    type={DraftItemListService.type}
  />
);

export default observer(DraftItemListFilterContainer);
